export default "https://cdn-static.gokick.com/assets/efda86aac2f53028585758eeb3b3c0048c8387b3/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";